export default "__VITE_ASSET__C5xJR3Ha__"